import { mapValues } from 'lodash';

import { Result } from '../Reports';

import { OrderInfo, OrderStatus } from './types';

/**
 * A function to set totals to 0 when an order has the CANCEL status.
 * @param perStoreOrders
 */
export const overrideCanceledOrders = (perStoreOrders: Result<OrderInfo>): Result<OrderInfo> =>
  mapValues(perStoreOrders, orders =>
    orders.map(order => ({
      ...order,
      orderTotalTaxExcluded:
        order.orderStatus !== OrderStatus.Cancelled ? order.orderTotalTaxExcluded : 0,
      orderTotalTaxIncluded:
        order.orderStatus !== OrderStatus.Cancelled ? order.orderTotalTaxIncluded : 0,
    })),
  );
